<template>
  <div style="width:220px" class="m-auto">
    <div v-for="(group,i) of colors" :key="i" class="p-x">
      <div class="text-center text-gray-100 font-bold">{{group.key}}</div>
      <div class="flex flex-wrap justify-evenly text-xs">
        <div v-for="(item,j) of group.value" :key="j">
          <VColorButton
            :tooltip="item"
            :color="getBg(item, group.type)"
            :selected="isClassSelected(item)"
            :text="group.type  == 'text' ? text : ''"
            @click.native="addClass(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { UiTabs } from "../../util";

export default {
  name: "VColorPanel",
  props: {
    colors: { default: [] },
    text: { default: "a" },
    type: { default: "bg" }
  },
  data() {
    return {
      tabs: new UiTabs(["Tags", "Classes"])
    };
  },
  mounted() {
    this.tabs.select("Tags");
  },
  computed: {
    ...mapGetters([
      "selectedNodeClassList",
      "selectedNodeParents",
      "isSelectedNode",
      "isClassSelected"
    ])
  },
  methods: {
    ...mapActions(["addClass", "deleteNode", "selectNode"]),
    getBg(item, type) {
      if (type == "bg") {
        return item;
      } else if (type == "text") {
        return item.replace("text", "bg");
      } else if (type === "border") {
        return "border " + item;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
.bg-tag {
  background: rgb(62, 61, 61);
}
.triangle {
  height: 0;
  width: 0;
  margin-left: -1px;
  border-left: 9px solid rgb(62, 61, 61);
  border-right: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-top: 9px solid transparent;
}
</style>
